/** Application-wide route paths. Single source of truth for routing. */
export const ROUTES = {
  HOME: "/",
  EVENTS: "/events",
  EVENT_DETAIL: "/events/:slug",
  MY_TICKETS: "/my-tickets",
  FAQ: "/faq",
  CONTACT: "/contact",
  ABOUT: "/about",
  PROFILE: "/profile",
  PAYMENT_RETURN: "/payment/return",
  PAYMENT_CANCEL: "/payment/cancel",
  TERMS: "/terminos",
  PRIVACY: "/privacidad",
} as const;
